import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [sector, setSector] = useState('');
  const [plan, setPlan] = useState('');
  const [cardInf, setCardInf] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const url = isLogin
      ? 'http://127.0.0.1/WhistleBlower/public/api/login'
      : 'http://127.0.0.1/WhistleBlower/public/api/entreprises';
  
    const payload = isLogin
      ? { email, password }
      : {
          email,
          password,
          name,
          location,
          sector,
          plan: parseInt(plan, 10),
        };
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const result = await response.json();
      console.log('Success:', result);
  
      // Store only the necessary user data (DO NOT store password or card information)
      const userData = {
        id: result.id,
        email: result.email,
        roles: result.roles,
        name: result.name,
        location: result.location,
        sector: result.sector,
        plan: result.plan,
      };
  
      localStorage.setItem('user', JSON.stringify(userData));
  
      // Redirect to dashboard
      navigate('/dashboard');
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('Failed to submit form');
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="toggle-buttons">
          <button
            className={`toggle-btn ${isLogin ? "active" : ""}`}
            onClick={() => setIsLogin(true)}
          >
            Login
          </button>
          <button
            className={`toggle-btn ${!isLogin ? "active" : ""}`}
            onClick={() => setIsLogin(false)}
          >
            Register
          </button>
        </div>

        <h2>{isLogin ? "Login" : "Register"}</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <div className="input-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {!isLogin && (
              <>
                <div className="input-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="location">Location</label>
                  <input
                    type="text"
                    id="location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="sector">Sector</label>
                  <input
                    type="text"
                    id="sector"
                    value={sector}
                    onChange={(e) => setSector(e.target.value)}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="plan">Plan</label>
                  <input
                    type="number"
                    id="plan"
                    value={plan}
                    onChange={(e) => setPlan(e.target.value)}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="card_inf">Card Information</label>
                  <input
                    type="text"
                    id="card_inf"
                    value={cardInf}
                    onChange={(e) => setCardInf(e.target.value)}
                    required
                  />
                </div>
              </>
            )}
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {!isLogin && (
            <div className="input-group">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input
                type="password"
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
          )}

          {errorMessage && <p className="error-message">{errorMessage}</p>}

          <button type="submit" className="submit-btn">
            {isLogin ? "Login" : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;